export const style = {
  container: {
    sx: {
      px: 2,
      py: 3,
    },
    Typography: {
      title: {
        variant: 'subtitle1',
        sx: {
          color: 'text.primary',
        },
      },
      text: {
        variant: 'body2',
        sx: {
          color: 'action.active',
        },
      },
    },
  },
} as const;
